import React, { useState, useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import Menubar from "./mainlayout/Menubar";
import Header from "./mainlayout/Header";
import { admin_auth } from "../redux/Authentication/AuthenticationSlice";
import { useDispatch } from "react-redux";
import { get_token_data } from "./utility/Get_token_data";

const Mainlayout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [menubar_Status, setMenubar_Status] = useState(false);
  const [admin_data, setadmin_data] = useState("");

  const onClose = () => {};

  useEffect(() => {
    const token = sessionStorage.getItem("fd_admin_token");
    if (token) {
      const admin = get_token_data();
      setadmin_data(admin.admin);
      const handleActivity = () => {
        clearTimeout(window.tokenExpirationTimer);
        window.tokenExpirationTimer = setTimeout(() => {
          sessionStorage.removeItem("fd_admin_token");
          dispatch(admin_auth(false));
          navigate("/");
        }, 5 * 60 * 1000);
      };

      window.addEventListener("mousemove", handleActivity);
      window.addEventListener("keydown", handleActivity);

      handleActivity();

      return () => {
        window.removeEventListener("mousemove", handleActivity);
        window.removeEventListener("keydown", handleActivity);
        clearTimeout(window.tokenExpirationTimer);
      };
    } else {
      navigate("/");
    }
  }, []);

  return (
    <>
      <div className="main_container_screen">
        <div className="main_container_menu">
          <div className="logo_container">
            <img src="/assets/logo/logo.jpg" alt="logo" />
          </div>
          <div className="menubar_container">
            <Menubar menubar_Status={menubar_Status} onClose={onClose} />
          </div>
        </div>
        <div className="main_container_dashbord">
          <Header admin_data={admin_data} />
          <div className="dashboard_container">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default Mainlayout;
